import { isValid as isValidCPF, format } from '@fnando/cpf'

export const FORMATTED_CPF_SIZE = 14

export const validateCPF = cpf => {
  if (!cpf) return false

  return isValidCPF(cpf)
}

export const formatCPF = cpf => format(cpf)
